import EventSendInvitations from './EventSendInvitations';

export default EventSendInvitations;
